function createTagHandler(params, event) {
    // !refactor find better way to get element
    const $element = $(this)[0].$element;
    const term = params.term.trim();

    const tagFormat = $element.data('tag-format');
    if (!!tagFormat && new RegExp(tagFormat).test(term) === false) {
        return null;
    }

    return {
        id: term,
        text: term,
        newTag: true // add additional parameters
    };
}

function changeHandler(e) {
    // @link https://stackoverflow.com/a/28657702
    e.preventDefault()
    const isNew = $(this).find('[data-select2-tag="true"]');

    if(isNew.length && $.inArray(isNew.val(), $(this).val()) !== -1){
        isNew.replaceWith('<option selected value="' + isNew.val() + '">' + isNew.val() + '</option>');
        $(this).trigger('select2:custom:tag-created', [isNew.val()]);
    }
}

export function attachSelect($context) {
    $.fn.select2.defaults.set("width", "100%");
    // component
    $context.find('select.select2-custom-search-disabled').select2({
        minimumResultsForSearch: Infinity,
        createTag: createTagHandler
    }).on("change", changeHandler);
    $context.find('select.select2-custom').select2({
        createTag: createTagHandler
    }).on("change", changeHandler);
}
